// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__25AHF","title":"AfterBackImages_title__2MyxZ","images":"AfterBackImages_images__1eaAb"};